/**
 * Test ID utilities for Toast component
 *
 * Pattern: All test IDs are generated via named setter functions.
 * This ensures consistency between components and tests.
 */

import { generateTestId } from "@client-shared";

/**
 * Generate test ID for Toast
 * @param identifier - Toast identifier or variant
 * @returns Test ID string
 */
export const setToastTestId = (identifier: string): string => generateTestId("Toast", identifier.replace(/\s+/g, "-").toLowerCase());

/**
 * Generate test ID for ToastAction
 * @param label - Action button label
 * @returns Test ID string
 */
export const setToastActionTestId = (label: string): string => generateTestId("ToastAction", label.replace(/\s+/g, "-").toLowerCase());

/**
 * Generate test ID for ToastClose
 * @param identifier - Toast identifier
 * @returns Test ID string
 */
export const setToastCloseTestId = (identifier: string = "default"): string =>
  generateTestId("ToastClose", identifier.replace(/\s+/g, "-").toLowerCase());

/**
 * Generate test ID for Toast icon
 * @param variant - Toast variant (default, success, destructive, warning)
 * @returns Test ID string
 */
export const setToastIconTestId = (variant: string = "default"): string =>
  generateTestId("ToastIcon", variant.replace(/\s+/g, "-").toLowerCase());
